import * as React from "react";
import Layout from "./Layout";
import {
    Box,
    Button,
    Container,
    Grid,
    Link,
    TextField,
    Typography,
} from "@mui/material";
import Nlink from "next/link";

const RegistracePage = () => {
    return (
        <Layout>
            <Container maxWidth={"md"}>
                <Typography component="h1" variant="h4" gutterBottom>
                    Jak se zapojit
                </Typography>
                <ol>
                    <li>
                        Přečti si{" "}
                        <Nlink href={"/podminky"} passHref>
                            <Link>podmínky</Link>
                        </Nlink>{" "}
                        účasti v soutěži.
                    </li>
                    <li>
                        Zaregistruj se do sportovního systému{" "}
                        <Link href={"https://strava.com"}>strava.com</Link>.
                        Strava je aplikace, která může sloužit jako tréninkový
                        deník, ale především poskytuje možnost porovnat se na
                        zvoleném úseku s ostatními běžci, kteří jej již také
                        absolvovali. Je to docela návyková funkce, které alespoň
                        na krátký čas naprosto propadnete. Ve své mobilní verzi
                        pro Android nebo iOS umožňuje zaznamenat aktivitu pomocí
                        Tvého smartphonu. Svůj účet můžeš ovládat buď skrze
                        zmíněnou mobilní aplikaci nebo přes webové rozhraní
                        (www.strava.com), skrze které můžeš nahrávat záznamy
                        svých aktivit také z dalších zařízení, jako jsou hodinky
                        s GPS nebo jiné GPS loggery. Pokud používáš zařízení
                        výrobců jako je Garmin, Suunto, Polar nebo TomTom můžeš
                        jednoduše své aktivity do Stravy nechat automaticky
                        nahrávat. Veškeré podrobnosti k této skvělé aplikaci
                        najdeš na stránkách{" "}
                        <Link href={"https://support.strava.com/hc/en-us"}>
                            oficiální podpory
                        </Link>
                        . Aplikace Vás bude lákat na různé trailové a bonusové
                        verze a sdílení kontaktů a tréninků, nebojte se vše
                        zamítnout. Základní verze je a bude zdarma. Taktéž
                        upozorňujeme, že je třeba, abyste měli vyplněné i
                        pohlaví. . Aplikace Vás bude lákat na různé trailové a
                        bonusové verze a sdílení kontaktů a tréninků, nebojte se
                        vše zamítnout. Základní verze je a bude zdarma. Taktéž
                        upozorňujeme, že je třeba, abyste měli{" "}
                        <b>vyplněné i&nbsp;pohlaví.</b>
                    </li>
                    <li>
                        <Box>Přihlaš se:</Box>

                        <Box sx={{ marginTop: "1rem" }}>
                            <SignIn />
                        </Box>
                    </li>
                    <li>
                        Pokud máš chuť, můžeš se v systému strava.com přihlásit
                        do klubu – Město Jeseník a získávat rychlé informace z
                        průběhu akce, či aktivitách ostatních účastníků „klubu
                        Jeseník“. získávat rychlé informace z průběhu akce, či
                        aktivitách ostatních účastníků „klubu Jeseník“.
                    </li>
                    <li>
                        Dobře se připrav na stanovený segment. V daném měsíci je
                        vždy aktivní jen jeden z nich. Zaběhni, nebo si vyjdi
                        stanovený segment a GPS záznam (klidně celý trénink)
                        ulož do aplikace strava.com.
                    </li>
                    <li>
                        Zkontroluj si ve výsledcích segmentu jak jsi dopadl a
                        hlídej svoje umístění. Důležité je, aby jste měli
                        aktivitu uloženou jako RUN (běh), jinak se Vám to se
                        segmentem nepropojí.
                    </li>
                    <li>
                        Prostuduj si trasu segmentu. Pokud si nejsi na rozcestí
                        jistá/ý, radši zastav a podívej se do mapy (pokud sejdeš
                        z trasy, nebudeme Tě moci zařadit do etapy). Pro
                        jednotlivé segmenty chystáme samostatné stránky, kde
                        bude zřejmé kde je start, trasa i místo cíle.
                    </li>
                </ol>

                <Typography component={"h2"} variant={"h4"} gutterBottom>
                    Časté dotazy
                </Typography>
                <ul>
                    <li>
                        PROČ MUSÍM POUŽÍT APLIKACI STRAVA? Protože nám Strava
                        nabízí skvělý nástroj, jak porovnat všechny účastníky
                        určité trasy - segmentu. Když zaznamenáš absolvování
                        etapy pomocí Stravy (nebo do ní následně záznam
                        nahraješ), spáruje se Tvoje aktivita s námi vytvořeným
                        segmentem (přesně nadefinovanou tratí) a my tak víme, že
                        jsi danou výzvu řádně absolvoval/a.
                    </li>
                    <li>
                        MŮŽU BĚŽET SEGMENT VÍCEKRÁT? Ano můžeš. Klidně můžeš
                        běžet jednu a tu samou etapu třeba 100x. Do výsledků se
                        Ti bude započítávat nejrychlejší pokus.
                    </li>
                    <li>
                        KDY SE BUDE MŮJ VÝKON ZAPOČÍTÁVAT DO SOUTĚŽE? Do soutěže
                        se započítá pouze ten pokus, který bude zaběhnutý v
                        období trvání daného segmentu. Příklad – 1. segment
                        Česká Ves bude přístupný od 1. 6. 201 do 30. 6. 2021.
                        Poslední segment Muzikantská stezka pak od 1.10. do 31.
                        10. 2021.
                    </li>
                    <li>
                        JAKÝ JE PRINCIP VYHODNOCENÍ? Pro letošní rok jsme se
                        rozhodli pro kategorie žen, mužů, veteránů a veteránek.
                        Hraniční je rok narození 1981. Hodnocení bude probíhat
                        ve dvou fázích:
                        <ol>
                            <li>
                                vyhodnotíme nejlepší časy v jednotlivých
                                etapách. Průběžně vyhodnotíme v dalším měsíci po
                                ukončení daného segmentu (příklad – 1. segment v
                                červenci 2021)
                            </li>
                            <li>
                                hodnotíme celou soutěž dohromady. Za každou
                                nejlepší účast v segmentu obdržíte počet bodů,
                                které budete sčítat dohromady. Máte tedy možnost
                                získat 6x počet bodů za určité místo v segmentu.
                                Na závěr celé akce provedeme vyhlášení výsledků,
                                kde ohodnotíme první 3 v každé kategorii.
                            </li>
                        </ol>
                    </li>
                    <li>
                        MUSÍM SE V PROKLIKU NA WEBU JESENÍK I STRAVA.COM
                        REGISTROVAT POKAŽDÉ, KDYŽ SI ZABĚHNU DALŠÍ POKUS? Ne,
                        registrovat se stačí pouze na začátku. Při dalších
                        pokusech musíš jen opět zaevidovat svoji snahu do GPS
                        řešení, které pak propojíš se systémem strava.com
                        Průběžné výsledky automaticky uvidíš segmentu strava.com
                        (dle evidence v měsíci), výsledky budou vyvěšeny na
                        našem webu a synchronizujeme průběžně.
                    </li>
                    <li>
                        CO DĚLAT, KDYŽ JSEM TRASU ETAPY PROBĚHL/A SPRÁVNĚ, ALE
                        STRAVA MĚ NEZAŘADILA DO DANÉHO SEGMENTU I na případy,
                        kdy může vlivem technologického selhání (např. vypadnutí
                        GPS signálu) k tomuto dojít Strava myslí. Proto
                        doporučujeme postupovat dle návodu. Je nutné počítat s
                        tím, že Vaše datové výstupy (tréninky) musí být v
                        systému strava.com veřejné. V ten moment se až
                        započítávají do segmentu.
                    </li>
                    <li>
                        NEDAŘÍ SE TI SPÁROVAT ZÁZNAM S ETAPOU? Pokud se nepodaří
                        Tvůj záznam spárovat s etapou ani podle výše popsaného
                        tipu, tak nám pošli URL adresu příslušného běhu na
                        Stravě na náš e-mail kubicek.hertin@gmail.com. Provedeme
                        kontrolu správného proběhnutí dané etapy a všech
                        nespárované výsledky přidáme do finálních výsledků, po
                        ukončení segmentů senZAČNI BĚH 2021.
                    </li>
                    <li>
                        Pokud nevidíte svůj výkon v segmentu, je možné, že jste
                        si zvolili aktivitu chůzi. Nicméně v rámci soutěže je
                        třeba Vaši aktivitu vést, nebo následně změnit na RUN
                        (běh). (To zda opravdu běžíte nebo jdete je samozřejmě
                        na Vás).
                    </li>
                </ul>
            </Container>
        </Layout>
    );
};

export default RegistracePage;

const SignIn = () => {
    const [value, setValue] = React.useState("");
    const [error, setError] = React.useState<string | null>(null);
    return (
        <Grid container spacing={2} alignItems={"center"}>
            <Grid item>
                <TextField
                    error={error != null}
                    helperText={error}
                    onChange={(event) => {
                        setValue(event.target.value);
                        setError(null);
                    }}
                    required
                    label="Rok narození"
                    type="number"
                    name={"born"}
                    value={value}
                />
            </Grid>
            <Grid item>
                <Button
                    onClick={() => {
                        if (value.match(/^[12]\d{3}$/i)) {
                            window.location.href = `https://www.strava.com/oauth/authorize?client_id=14507&redirect_uri=https%3A%2F%2Fstrava.logee.cz%2Fstrava-callback.html%3Fproject%3DsenZacniBeh2021%26year%3D${value}&response_type=code&scope=activity%3Aread&year=${value}`;
                        } else {
                            setError("Neplatný formát. Validní příklad: 1989");
                        }
                    }}
                    variant={"contained"}
                >
                    Přihlásit se do senZAČNI BĚH 2021
                </Button>
            </Grid>
        </Grid>
    );
};
